// settings for back to top button
const btt = () => {
  const bttEl = document.querySelectorAll('.btt');

  if (!bttEl.length) return;

  bttEl.forEach((el) => {
    el.addEventListener('click', () => {
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    });
  });

  if (window.innerWidth <= 1080) return;
  document.addEventListener('scroll', () => {
    if (window.scrollY > window.innerHeight / 2) {
      bttEl[0].classList.add('is-visible');
    } else {
      bttEl[0].classList.remove('is-visible');
    }
  });
};

export default btt;
